import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ModalCustom } from "../../../../components/ModalCustom";

  export default function ModalEnergySite({sitesEnergy,setParagonSiteID,setOpenModalEnergySite,setOpenModalPar,
    openModalEnergySite
  }) {
    const configModalVariables = {
      configModal: {
        defaultExpanded:true,
        sxStyle:{width: { xs: "100%", sm: "20%" }},
    }}
    return (
      <ModalCustom  {...configModalVariables.configModal}
          onClose={() => setOpenModalEnergySite(false)} 
          open={openModalEnergySite}>
        <Box paddingTop={1} width={"100%"}>
            <TableContainer component={Paper} sx={{maxHeight:"auto"}}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Lista siti con Energy</TableCell>
                </TableRow>
              </TableHead>
              </Table>
            <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
              <Table size="small" style={{ width: '100%' }}>
                <TableBody>
                    {sitesEnergy.sites.map((site, index) => (
                      <TableRow key={index} 
                                hover
                                sx={{ cursor: "pointer" }}
                                onClick={()=>{setParagonSiteID(site.id); setOpenModalEnergySite(false); setOpenModalPar(true)}}>
                        <TableCell className="variables-color">{site.brand} - {site.name}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </TableContainer>
        </Box>  
      </ModalCustom>       
    )
  }
